 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import MAINCOVER from '@/components/main-cover'
 import LOVE_1 from '@/components/love_1'
 import MAINTP from '@/components/main-tp'
 import MAINTOC from '@/components/main-toc'
 import FM from '@/components/FM'
 import INTRODUCTION from '@/components/Introduction'
 import PROLOGUE from '@/components/Prologue'
 import DISPERSION from '@/components/Dispersion'
 import FREEDOM from '@/components/Freedom'
 import DELIVERER from '@/components/Deliverer'
 import THREE_LIVES from '@/components/Three_Lives'
 import PART_I from '@/components/Part_I'
 import ONE from '@/components/One'
 import TWO from '@/components/Two'
 import THREE from '@/components/Three'
 import FOUR from '@/components/Four'
 import FIVE from '@/components/Five'
 import SIX from '@/components/Six'
 import SEVEN from '@/components/Seven'
 import EIGHT from '@/components/Eight'
 import NINE from '@/components/Nine'
 import TEN from '@/components/Ten'
 import ELEVEN from '@/components/Eleven'
 import TWELVE from '@/components/Twelve'
 import PART_II from '@/components/Part_II'
 import THIRTEEN from '@/components/Thirteen'
 import FOURTEEN from '@/components/Fourteen'
 import FIFTEEN from '@/components/Fifteen'
 import SIXTEEN from '@/components/Sixteen'
 import SEVENTEEN from '@/components/Seventeen'
 import EIGHTEEN from '@/components/Eighteen'
 import NINETEEN from '@/components/Nineteen'
 import TWENTY from '@/components/Twenty'
 import TWENTYONE from '@/components/Twenty-One'
 import TWENTYTWO from '@/components/Twenty-Two'
 import TWENTYTHREE from '@/components/Twenty-Three'
 import TWENTYFOUR from '@/components/Twenty-Four'
 import PART_III from '@/components/Part_III'
 import TWENTYFIVE from '@/components/Twenty-Five'
 import TWENTYSIX from '@/components/Twenty-Six'
 import TWENTYSEVEN from '@/components/Twenty-Seven'
 import TWENTYEIGHT from '@/components/Twenty-Eight'
 import TWENTYNINE from '@/components/Twenty-Nine'
 import THIRTY from '@/components/Thirty'
 import THIRTYONE from '@/components/Thirty-One'
 import THIRTYTWO from '@/components/Thirty-Two'
 import THIRTYTHREE from '@/components/Thirty-Three'
 import THIRTYFOUR from '@/components/Thirty-Four'
 import THIRTYFIVE from '@/components/Thirty-Five'
 import THIRTYSIX from '@/components/Thirty-Six'
 import THIRTYSEVEN from '@/components/Thirty-Seven'
 import THIRTYEIGHT from '@/components/Thirty-Eight'
 import PART_IV from '@/components/Part_IV'
 import THIRTYNINE from '@/components/Thirty-Nine'
 import FORTY from '@/components/Forty'
 import FORTYONE from '@/components/Forty-One'
 import FORTYTWO from '@/components/Forty-Two'
 import FORTYTHREE from '@/components/Forty-Three'
 import FORTYFOUR from '@/components/Forty-Four'
 import FORTYFIVE from '@/components/Forty-Five'
 import FORTYSIX from '@/components/Forty-Six'
 import FORTYSEVEN from '@/components/Forty-Seven'
 import FORTYEIGHT from '@/components/Forty-Eight'
 import FORTYNINE from '@/components/Forty-Nine'
 import FIFTY from '@/components/Fifty'
 import FIFTYONE from '@/components/Fifty-One'
 import FIFTYTWO from '@/components/Fifty-Two'
 import FIFTYTHREE from '@/components/Fifty-Three'
 import FIFTYFOUR from '@/components/Fifty-Four'
 import FIFTYFIVE from '@/components/Fifty-Five'
 import FAMILIES from '@/components/Families'
 import ENDNOTES from '@/components/Endnotes'
 import CH01B from '@/components/ch01b'
 import CH02B from '@/components/ch02b'
 import CH03B from '@/components/ch03b'
 import CH04B from '@/components/ch04b'
 import CH05B from '@/components/ch05b'
 import CH06B from '@/components/ch06b'
 import CH07B from '@/components/ch07b'
 import CH08B from '@/components/ch08b'
 import CH09B from '@/components/ch09b'
 import CH10B from '@/components/ch10b'
 import CH11B from '@/components/ch11b'
 import CH12B from '@/components/ch12b'
 import CH13B from '@/components/ch13b'
 import CH14B from '@/components/ch14b'
 import CH15B from '@/components/ch15b'
 import CH16B from '@/components/ch16b'
 import CH17B from '@/components/ch17b'
 import CH18B from '@/components/ch18b'
 import CH19B from '@/components/ch19b'
 import CH20B from '@/components/ch20b'
 import CH21B from '@/components/ch21b'
 import CH22B from '@/components/ch22b'
 import CH23B from '@/components/ch23b'
 import CH24B from '@/components/ch24b'
 import CH25B from '@/components/ch25b'
 import CH26B from '@/components/ch26b'
 import CH27B from '@/components/ch27b'
 import CH28B from '@/components/ch28b'
 import CH29B from '@/components/ch29b'
 import CH30B from '@/components/ch30b'
 import CH31B from '@/components/ch31b'
 import CH32B from '@/components/ch32b'
 import CH33B from '@/components/ch33b'
 import CH34B from '@/components/ch34b'
 import CH35B from '@/components/ch35b'
 import CH36B from '@/components/ch36b'
 import CH37B from '@/components/ch37b'
 import CH38B from '@/components/ch38b'
 import CH39B from '@/components/ch39b'
 import CH40B from '@/components/ch40b'
 import CH41B from '@/components/ch41b'
 import CH42B from '@/components/ch42b'
 import CH43B from '@/components/ch43b'
 import CH44B from '@/components/ch44b'
 import CH45B from '@/components/ch45b'
 import CH46B from '@/components/ch46b'
 import CH47B from '@/components/ch47b'
 import CH48B from '@/components/ch48b'
 import CH49B from '@/components/ch49b'
 import CH50B from '@/components/ch50b'
 import CH51B from '@/components/ch51b'
 import CH52B from '@/components/ch52b'
 import CH53B from '@/components/ch53b'
 import CH54B from '@/components/ch54b'
 import CH55B from '@/components/ch55b'
 import CH56B from '@/components/ch56b'
 import CH57B from '@/components/ch57b'
 import CH58B from '@/components/ch58b'
 import CH59B from '@/components/ch59b'
 import CH60B from '@/components/ch60b'
 import CH61B from '@/components/ch61b'
 import CH62B from '@/components/ch62b'
 import CH63B from '@/components/ch63b'
 import CH64B from '@/components/ch64b'
 import CH65B from '@/components/ch65b'
 import CH66B from '@/components/ch66b'
 import CH67B from '@/components/ch67b'
 import CH68B from '@/components/ch68b'
 import CH69B from '@/components/ch69b'
 import CH70B from '@/components/ch70b'
 import CH71B from '@/components/ch71b'
 import CH72B from '@/components/ch72b'
 import CH73B from '@/components/ch73b'
 import CH74B from '@/components/ch74b'
 import CH75B from '@/components/ch75b'
 import CH76B from '@/components/ch76b'
 import CH77B from '@/components/ch77b'
 import CH78B from '@/components/ch78b'
 import CH001 from '@/components/ch001'
 import CH002 from '@/components/ch002'
 import CH003 from '@/components/ch003'
 import CH004 from '@/components/ch004'
 import CH005 from '@/components/ch005'
 import CH006 from '@/components/ch006'
 import CH007 from '@/components/ch007'
 import CH008 from '@/components/ch008'
 import CH009 from '@/components/ch009'
 import CH010 from '@/components/ch010'
 import CH011 from '@/components/ch011'
 import CH012 from '@/components/ch012'
 import CH013 from '@/components/ch013'
 import CH014 from '@/components/ch014'
 import CH015 from '@/components/ch015'
 import CH016 from '@/components/ch016'
 import CH017 from '@/components/ch017'
 import CH018 from '@/components/ch018'
 import CH019 from '@/components/ch019'
 import CH020 from '@/components/ch020'
 import CH021 from '@/components/ch021'
 import CH022 from '@/components/ch022'
 import CH023 from '@/components/ch023'
 import CH024 from '@/components/ch024'
 import CH025 from '@/components/ch025'
 import CH026 from '@/components/ch026'
 import CH027 from '@/components/ch027'
 import CH028 from '@/components/ch028'
 import CH029 from '@/components/ch029'
 import CH030 from '@/components/ch030'
 import CH031 from '@/components/ch031'
 import CH032 from '@/components/ch032'
 import CH033 from '@/components/ch033'
 import CH034 from '@/components/ch034'
 import CH035 from '@/components/ch035'
 import CH036 from '@/components/ch036'
 import CH037 from '@/components/ch037'
 import CH038 from '@/components/ch038'
 import CH039 from '@/components/ch039'
 import CH040 from '@/components/ch040'
 import CH041 from '@/components/ch041'
 import CH042 from '@/components/ch042'
 import CH043 from '@/components/ch043'
 import CH044 from '@/components/ch044'
 import CH045 from '@/components/ch045'
 import CH046 from '@/components/ch046'
 import CH047 from '@/components/ch047'
 import CH048 from '@/components/ch048'
 import CH049 from '@/components/ch049'
 import CH050 from '@/components/ch050'
 import CH051 from '@/components/ch051'
 import CH052 from '@/components/ch052'
 import CH053 from '@/components/ch053'
 import CH054 from '@/components/ch054'
 import CH055 from '@/components/ch055'
 import CH056 from '@/components/ch056'
 import CH057 from '@/components/ch057'
 import CH058 from '@/components/ch058'
 import CH059 from '@/components/ch059'
 import CH060 from '@/components/ch060'
 import CH061 from '@/components/ch061'
 import CH062 from '@/components/ch062'
 import CH063 from '@/components/ch063'
 import CH064 from '@/components/ch064'
 import CH065 from '@/components/ch065'
 import CH066 from '@/components/ch066'
 import CH067 from '@/components/ch067'
 import CH068 from '@/components/ch068'
 import CH069 from '@/components/ch069'
 import CH070 from '@/components/ch070'
 import CH071 from '@/components/ch071'
 import CH072 from '@/components/ch072'
 import CH073 from '@/components/ch073'
 import CH074 from '@/components/ch074'
 import CH075 from '@/components/ch075'
 import CH076 from '@/components/ch076'
 import CH077 from '@/components/ch077'
 import CH078 from '@/components/ch078'
 import CH079 from '@/components/ch079'
 import CH080 from '@/components/ch080'
 import CH081 from '@/components/ch081'
 import CH082 from '@/components/ch082'
 import CH083 from '@/components/ch083'
 import CH084 from '@/components/ch084'
 import CH085 from '@/components/ch085'
 import CH086 from '@/components/ch086'
 import CH087 from '@/components/ch087'
 import CH088 from '@/components/ch088'
 import CH089 from '@/components/ch089'
 import CH090 from '@/components/ch090'
 import CH091 from '@/components/ch091'
 import CH092 from '@/components/ch092'
 import CH093 from '@/components/ch093'
 import CH094 from '@/components/ch094'
 import CH095 from '@/components/ch095'
 import CH096 from '@/components/ch096'
 import CH097 from '@/components/ch097'
 import CH098 from '@/components/ch098'
 import CH099 from '@/components/ch099'
 import CH100 from '@/components/ch100'
 import CH101 from '@/components/ch101'
 import CH102 from '@/components/ch102'
 import CH103 from '@/components/ch103'
 import CH104 from '@/components/ch104'
 import LOVE_2 from '@/components/love_2'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/main-cover",
 			"name" : "main-cover",
 			"component" : MAINCOVER
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/main-tp",
 			"name" : "main-tp",
 			"component" : MAINTP
 		},
 		{
 			"path" : "/main-toc",
 			"name" : "main-toc",
 			"component" : MAINTOC
 		},
 		{
 			"path" : "/FM",
 			"name" : "FM",
 			"component" : FM
 		},
 		{
 			"path" : "/Introduction",
 			"name" : "Introduction",
 			"component" : INTRODUCTION
 		},
 		{
 			"path" : "/Prologue",
 			"name" : "Prologue",
 			"component" : PROLOGUE
 		},
 		{
 			"path" : "/Dispersion",
 			"name" : "Dispersion",
 			"component" : DISPERSION
 		},
 		{
 			"path" : "/Freedom",
 			"name" : "Freedom",
 			"component" : FREEDOM
 		},
 		{
 			"path" : "/Deliverer",
 			"name" : "Deliverer",
 			"component" : DELIVERER
 		},
 		{
 			"path" : "/Three_Lives",
 			"name" : "Three_Lives",
 			"component" : THREE_LIVES
 		},
 		{
 			"path" : "/Part_I",
 			"name" : "Part_I",
 			"component" : PART_I
 		},
 		{
 			"path" : "/One",
 			"name" : "One",
 			"component" : ONE
 		},
 		{
 			"path" : "/Two",
 			"name" : "Two",
 			"component" : TWO
 		},
 		{
 			"path" : "/Three",
 			"name" : "Three",
 			"component" : THREE
 		},
 		{
 			"path" : "/Four",
 			"name" : "Four",
 			"component" : FOUR
 		},
 		{
 			"path" : "/Five",
 			"name" : "Five",
 			"component" : FIVE
 		},
 		{
 			"path" : "/Six",
 			"name" : "Six",
 			"component" : SIX
 		},
 		{
 			"path" : "/Seven",
 			"name" : "Seven",
 			"component" : SEVEN
 		},
 		{
 			"path" : "/Eight",
 			"name" : "Eight",
 			"component" : EIGHT
 		},
 		{
 			"path" : "/Nine",
 			"name" : "Nine",
 			"component" : NINE
 		},
 		{
 			"path" : "/Ten",
 			"name" : "Ten",
 			"component" : TEN
 		},
 		{
 			"path" : "/Eleven",
 			"name" : "Eleven",
 			"component" : ELEVEN
 		},
 		{
 			"path" : "/Twelve",
 			"name" : "Twelve",
 			"component" : TWELVE
 		},
 		{
 			"path" : "/Part_II",
 			"name" : "Part_II",
 			"component" : PART_II
 		},
 		{
 			"path" : "/Thirteen",
 			"name" : "Thirteen",
 			"component" : THIRTEEN
 		},
 		{
 			"path" : "/Fourteen",
 			"name" : "Fourteen",
 			"component" : FOURTEEN
 		},
 		{
 			"path" : "/Fifteen",
 			"name" : "Fifteen",
 			"component" : FIFTEEN
 		},
 		{
 			"path" : "/Sixteen",
 			"name" : "Sixteen",
 			"component" : SIXTEEN
 		},
 		{
 			"path" : "/Seventeen",
 			"name" : "Seventeen",
 			"component" : SEVENTEEN
 		},
 		{
 			"path" : "/Eighteen",
 			"name" : "Eighteen",
 			"component" : EIGHTEEN
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js